import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import Button from './Button';
import { LeaveCategoryCalculation } from '../../shared/types.js';

interface NameEditModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (data: { name: string; calculation?: LeaveCategoryCalculation }) => void;
    initialName?: string;
    title: string;
    initialCalculation?: LeaveCategoryCalculation;
    showCalculation?: boolean;
}

const NameEditModal: React.FC<NameEditModalProps> = ({ isOpen, onClose, onSave, initialName = '', title, initialCalculation, showCalculation }) => {
    const [name, setName] = useState(initialName);
    const [calculation, setCalculation] = useState<LeaveCategoryCalculation>(LeaveCategoryCalculation.PAID);

    useEffect(() => {
        if (isOpen) {
            setName(initialName);
            setCalculation(initialCalculation || LeaveCategoryCalculation.PAID);
        }
    }, [isOpen, initialName, initialCalculation]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (name.trim()) {
            onSave({ name: name.trim(), calculation: showCalculation ? calculation : undefined });
        }
    };

    const inputClass = "mt-1 block w-full bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 rounded-md shadow-sm py-2 px-3 text-gray-900 dark:text-white focus:outline-none focus:ring-brand-secondary focus:border-brand-secondary";
    const labelClass = "block text-sm font-medium text-gray-600 dark:text-gray-300";

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="item-name" className={labelClass}>Name</label>
                    <input
                        id="item-name"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        className={inputClass}
                        autoFocus
                    />
                </div>
                 {showCalculation && (
                    <div>
                        <label htmlFor="item-calculation" className={labelClass}>Classification</label>
                        <select
                            id="item-calculation"
                            value={calculation}
                            onChange={(e) => setCalculation(e.target.value as LeaveCategoryCalculation)}
                            className={inputClass}
                        >
                            <option value={LeaveCategoryCalculation.PAID}>Paid</option>
                            <option value={LeaveCategoryCalculation.UNPAID}>Unpaid</option>
                        </select>
                    </div>
                )}
                <div className="flex justify-end gap-4 pt-4">
                    <Button type="button" variant="secondary" onClick={onClose}>Cancel</Button>
                    <Button type="submit">Save</Button>
                </div>
            </form>
        </Modal>
    );
};

export default NameEditModal;